import * as speakeasy from 'speakeasy';
import moment from 'moment';
import {
  AuthState,
  LOGIN,
  LOGOUT,
  APPCRASH,
  SET_DEBUG,
  AuthActionTypes} from './Types';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import {AccessToken, Login} from '../../Services/TokenService';
import {ThunkResult} from '../index';

export const login = (clientCode: string, token: AccessToken): AuthActionTypes => {
  return {
    type: LOGIN,
    payload: {
      clientCode,
      token,
    },
  };
};

export const logout = (): AuthActionTypes => {
  return {
    type: LOGOUT,
  };
};

export const crash = (): AuthActionTypes => {
  return {
    type: APPCRASH,
  };
};

export const setDebug = (debug: boolean): AuthActionTypes => {
  return {
    type: SET_DEBUG,
    payload: debug,
  };
};

export const loginCreator = (): ThunkResult<Promise<AuthState>> => {
  return async (dispatch, getState) => {
    const {auth: {
      officeCompanionService,
      tokenService,
    }} = getState();

    let code: string;
    let password: string;
    if (process.env.NODE_ENV === 'development') {
      code = 'ADMIN';
      password = speakeasy.totp({secret: '020007'});
    } else {
      code = await officeCompanionService.getClientCode();
      password = '';
      if (code === 'ADMIN') {
        password = await officeCompanionService.getPassword();
      }
    }
    const username = await officeCompanionService.getUsername();

    try {
      const model = new Login(code, password, username);
      const res = await tokenService.logIn(model);
      if (res.parsedBody !== undefined) {
        dispatch(login(code, res.parsedBody));
        scheduleRefresh(dispatch, res.parsedBody.expiration);
      }
    } catch (e) {
      console.log(e);
    }

    return getState().auth;
  };
};

export const refreshCreator = (): ThunkResult<Promise<void>> => {
  return async (dispatch, getState) => {
    const {
      auth: {
        token: {
          refreshToken,
        },
        officeCompanionService,
        tokenService,
      },
    } = getState();
    let code: string;
    if (process.env.NODE_ENV === 'development') {
      code = 'ADMIN';
    } else {
      code = await officeCompanionService.getClientCode();
    }

    try {
      const res = await tokenService.refresh(code, refreshToken);
      if (res.parsedBody !== undefined) {
        dispatch(login(code, res.parsedBody));
        scheduleRefresh(dispatch, res.parsedBody.expiration);
      }
    } catch (e) {
      console.log(e);
    }
  };
};

const scheduleRefresh = (dispatch: ThunkDispatch<any, any, AnyAction>, expiration: Date) => {
  const diff = -(moment().diff(expiration)) - 60 * 1000;

  setTimeout(() => {
    dispatch(refreshCreator());
  }, diff);
};

export const openDevToolsCreator = (): ThunkResult<Promise<void>> => {
  return async (dispatch, getState) => {
    const {auth: {officeCompanionService}} = getState();

    await officeCompanionService.openDevTools();
  };
};

